module.exports = "https://img1.huilianyi.com/b/avoid-print-flag@2x.b0fe922374.appcore.png";